exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appFesHeader[data-v-35d1f3a8]{background:#fff;padding:8px 12px;border-bottom:1px solid #efefef}@media (min-width:768px){.appFesHeader[data-v-35d1f3a8]{padding:16px 24px}}.appFesHeader__brand[data-v-35d1f3a8]{width:82px;height:28px;display:block}.appFesHeader__brand>img[data-v-35d1f3a8]{width:100%}@media (min-width:768px){.appFesHeader__brand[data-v-35d1f3a8]{width:140px;height:48px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35d1f3a8","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/uFes/components/AppFesHeader.vue
// module id = w9iN
// module chunks = 0